import { appInfo } from "../../network/service"
import { fetchApiData, getVvLink } from "../../utils/utils"

export const getMenuItems=async (appInfo)=>{
  const api='menu/items'
  const vvLink = getVvLink();
  
  let params = {};
  if (vvLink) {
    params.vv_link = vvLink;
  }
  
  return await fetchApiData(appInfo, api, params)
}

